// extracted by mini-css-extract-plugin
export default {"author":"Carconfig__author--Rj3HK","hero":"HighlightsHero__hero--Nsbjc"};